<template functional>
	<svg
		role="presentation"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		:width="props.size"
		:height="props.size"
		viewBox="0 0 16 16"
	>
		<path
			d="M13.5 2.75H2.5C2.10218 2.75 1.72064 2.90804 1.43934 3.18934C1.15804 3.47064 1 3.85218 1 4.25V10.75C1 11.1478 1.15804 11.5294 1.43934 11.8107C1.72064 12.092 2.10218 12.25 2.5 12.25H6.25V13.25H5.25C5.05109 13.25 4.86032 13.329 4.71967 13.4697C4.57902 13.6103 4.5 13.8011 4.5 14C4.5 14.1989 4.57902 14.3897 4.71967 14.5303C4.86032 14.671 5.05109 14.75 5.25 14.75H10.75C10.9489 14.75 11.1397 14.671 11.2803 14.5303C11.421 14.3897 11.5 14.1989 11.5 14C11.5 13.8011 11.421 13.6103 11.2803 13.4697C11.1397 13.329 10.9489 13.25 10.75 13.25H9.75V12.25H13.5C13.8978 12.25 14.2794 12.092 14.5607 11.8107C14.842 11.5294 15 11.1478 15 10.75V4.25C15 3.85218 14.842 3.47064 14.5607 3.18934C14.2794 2.90804 13.8978 2.75 13.5 2.75ZM13.5 10.75H2.5V4.25H13.5V10.75Z"
			fill="#74788D"
		/>
		<path
			d="M6.75 8.94004V6.06004C6.74991 6.00838 6.76316 5.95756 6.78847 5.9125C6.81377 5.86744 6.85027 5.82966 6.8945 5.80279C6.93872 5.77592 6.98915 5.76087 7.04093 5.75908C7.09271 5.75729 7.14406 5.76882 7.19 5.79254L9.845 7.23254C9.89432 7.25736 9.93576 7.29542 9.96468 7.34246C9.9936 7.3895 10.0089 7.44366 10.0089 7.49879C10.0089 7.55392 9.9936 7.60808 9.96468 7.65512C9.93576 7.70216 9.89432 7.74022 9.845 7.76504L7.19 9.20504C7.14406 9.22876 7.09271 9.24029 7.04093 9.2385C6.98915 9.23671 6.93872 9.22166 6.8945 9.19479C6.85027 9.16792 6.81377 9.13014 6.78847 9.08508C6.76316 9.04002 6.74991 8.9892 6.75 8.93754V8.94004Z"
			fill="#74788D"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconTrainings',

	props: {
		size: { type: [String, Number], default: '16px' },
	}
}
</script>
